<section
  class="container section-bar"
  [ngClass]="{ 'pointer-events-none': dataCount() <= 0 }">
  <a [routerLink]="link()" [queryParams]="params" class="section-bar__flex">
    <i class="iconsax section-bar__icon" [attr.icon-name]="icon()"></i>
    <p class="section-bar__title">{{ barTitle() | translate }}</p>
  </a>
  <a
    [routerLink]="link()"
    [queryParams]="params"
    class="section-bar__link"
    [ngClass]="{ 'pointer-events-none': dataCount() <= 0 }">
    <span>{{ dataCount() }}</span>
    <span>{{ dataTitle() | translate }}</span>
  </a>
</section>
